import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./DashboardPage.css";
import AnalyticsBarChart from "../../components/common/analyticsBarChart";
import Cards from "../../components/common/cards";
import { getPageTitle } from "../../utils/getPageTitle";
import RecentActivity from "../../components/common/recentActivity";
import LineChartComponent from "../../components/common/activeUserLineChart";

export default function DashboardPage() {
  const location = useLocation();
  //   const navigate = useNavigate();
  //   const handleLogout = () => {
  //     localStorage.removeItem('token');
  //     localStorage.removeItem('user');
  //     navigate('/login');
  //   };

  return (
    <>
      <h1 className="page-title">{getPageTitle(location.pathname)}</h1>
      <p style={{ color: "rgb(85, 85, 85)", fontSize: "13px" }}>
        Welcome back! Here’s what’s happening with your platform
      </p>
      <Cards />
      <div className="dashboard-content">
        {/* <div className="welcome-card">
          <h2>Welcome to Indeva Admin Panel!</h2>
          <p>You have successfully logged in.</p>
        </div> */}
        <LineChartComponent
          title="User Activity"
          subtitle="Monthly user growth trend"
        />
        <AnalyticsBarChart
          title="Share Analytics"
          subtitle="Weekly share distribution"
          height={300}
          showGrid={true}
          showLegend={false}
        />
        {/* <UsersPieChart /> */}
      </div>

      <RecentActivity />
    </>
  );
}